// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left {
  width: 100%;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  padding: 0px !important;
  cursor: auto;
  /* gap: 13px; */
}

.content-new {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
}

.content-new-0 {
  display: flex;
  align-items: flex-start;
  justify-items: center;
}

.content-typo {
  display: flex;
  align-items: center;
  font-family: "karla" !important;
  font-size: .6vw ;
  font-weight: 400 !important;
  line-height: 1.2vw !important ;
}

.content-typo-0 {
  display: flex;
  align-items: center;
  font-family: karla !important;
  font-size: .9vw !important;
  font-weight: 500;
  line-height: 1.5vw !important;
}

.card-image {
  /* height: 130px !important;
  width: 130px !important; */
  border-radius: .25vw !important;
  cursor: pointer !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/cards/scannedCard/scannedCard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE;4BAC0B;EAC1B,+BAA+B;EAC/B,0BAA0B;AAC5B","sourcesContent":[".left {\n  width: 100%;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  justify-content: flex-start !important;\n  padding: 0px !important;\n  cursor: auto;\n  /* gap: 13px; */\n}\n\n.content-new {\n  display: flex;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.content-new-0 {\n  display: flex;\n  align-items: flex-start;\n  justify-items: center;\n}\n\n.content-typo {\n  display: flex;\n  align-items: center;\n  font-family: \"karla\" !important;\n  font-size: .6vw ;\n  font-weight: 400 !important;\n  line-height: 1.2vw !important ;\n}\n\n.content-typo-0 {\n  display: flex;\n  align-items: center;\n  font-family: karla !important;\n  font-size: .9vw !important;\n  font-weight: 500;\n  line-height: 1.5vw !important;\n}\n\n.card-image {\n  /* height: 130px !important;\n  width: 130px !important; */\n  border-radius: .25vw !important;\n  cursor: pointer !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
